import { getConfig } from '@/services/inqueryServices'
import _ from 'lodash'
import i18n from '@/lib/language'
import { isMobile } from '@/lib/device'
import { fetchClueFieldkeys } from '@/services/clue'
const state = {
  loading: true,
  configData: {},
  baseinfo: null,
  isClue: false
}

const getters = {
  fromInfo (state) {
    const { configData = {} } = state
    const { from_info: fromInfo = {}, info = {} } = configData
    const { child = [] } = fromInfo
    if (!fromInfo) return

    let data = {
      ...fromInfo,
      fieldtype: 'select',
      childObj: _.reduce(
        child,
        (res, item) => {
          res[item.id] = item
          return res
        },
        {}
      ),
      options: [],
      fieldconfig: {
        placeholder: i18n.t('message["887"]')
      },
      isneeded: Object.keys(info).includes('select') ? 0 : 1,
      fieldvalue: fromInfo.fieldvalue || ''
    }
    if (child.length) {
      child.forEach(item => {
        let obj = { id: item.id, name: item.fieldname, fieldkey: item.fieldkey }
        // if (item.child && item.child.length) {
        data.options.push(obj)
        // }
      })
    }
    return data
  },
  defaultMemberInfo () {
    const { configData = {} } = state
    const { info } = configData
    return info
  },
  memberInfo (state, getters, rootState) {
    const { baseinfo = {} } = rootState
    const { configData = {} } = state
    const { info = {} } = configData
    let child = []
    if (!configData || !info) return

    let childValueObj = {}
    for (let k in info) {
      if (k.indexOf('_') !== -1) {
        if (k === 'audit_status_desc') continue

        const key = k.split('_') && k.split('_')[0]
        const key2 = k.split('_') && k.split('_')[1]

        if (
          key === 'input' ||
          key === 'audit' ||
          key === 'dev' ||
          key === 'follow'
        ) {
          childValueObj[key] = childValueObj[key] || {}
          childValueObj[key][key2] = info[k]
        }
      }
    }
    if (Object.keys(info).includes('select')) {
      child = [
        {
          fieldkey: 'inputName',
          fieldname: i18n.t('message["620"]'),
          fieldtype: 'string',
          fieldvalue: baseinfo.truename,
          isneeded: 1
        },
        {
          fieldkey: 'group',
          key: 'input',
          fieldname: i18n.t('message["1159"]'),
          fieldtype: 'cascader',
          fieldvalue: [],
          fieldconfig: {
            enableinput: 1
          },
          isneeded: 1,
          info: childValueObj.input
        },
        {
          fieldkey: 'dev',
          fieldname: '线索跟进人员',
          fieldtype: 'cascader',
          fieldvalue: [],
          fieldconfig: {
            enableinput: 1
          },
          isneeded: 1,
          info: childValueObj.dev
        }
      ]
    } else {
      child = [
        {
          fieldkey: 'inputName',
          fieldname: i18n.t('message["620"]'),
          fieldtype: 'string',
          fieldvalue: baseinfo.truename
        },
        {
          fieldkey: 'group',
          key: 'input',
          fieldname: i18n.t('message["1159"]'),
          fieldtype: 'cascader',
          fieldvalue: [],
          fieldconfig: {
            enableinput: 1
          },
          isneeded: 1,
          info: childValueObj.input
        },
        {
          fieldkey: 'dev',
          fieldname: i18n.t('message["549"]'),
          fieldtype: 'cascader',
          fieldvalue: [],
          fieldconfig: {
            enableinput: 1
          },
          isneeded: info.devuser_isneeded === 1 ? 1 : 0,
          info: childValueObj.dev
        },
        {
          fieldkey: 'follow',
          fieldname: i18n.t('message["373"]'),
          fieldtype: 'cascader',
          fieldvalue: [],
          fieldconfig: {
            enableinput: 1
          },
          isneeded: 1,
          info: childValueObj.follow
        }
      ]
    }
    return { child }
  },
  formData (state, getters) {
    const { configData = {} } = state

    let data = {
      /* base_info: configData.base_info || {},
      deal_info: configData.deal_info || {},
      demand_info: configData.demand_info || {},
      contact_info: configData.contact_info || {},
      reception_info: configData.reception_info || {}, */
      ...configData,
      from_info: {},
      info: {
        id: '',
        fieldkey: 'info',
        fieldname: i18n.t('message["933"]'),
        is_shared: false,
        child: []
      }
    }
    if (data.reception_info) {
      delete data.reception_info.sort
    }

    data.from_info = getters.fromInfo
    data.info.child = getters.memberInfo.child.slice(
      0,
      getters.memberInfo.child.length
    )

    return data
  },
  permissionInfo (state) {
    const { permission_info: permissionInfo = {} } = state.configData || {}
    return permissionInfo
  },
  isNeedAudit (state) {
    const { permission_info: permissionInfo = {} } = state.configData || {}
    const { is_need_audit: isNeedAudit } = permissionInfo
    return isNeedAudit
  }
}

const mutations = {
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_ADD_CONFIG (state, data) {
    Object.assign(state.configData, [])
    state.configData = data
  },
  setBaseInfo (state, data) {
    state.baseinfo = data
  },
  setIsClue (state, b) {
    state.isClue = b
  }
}

const actions = {
  async fetchDetail ({ commit, dispatch }, data) {
    commit('SET_LOADING', true)
    let chain = null
    if (data && data.type && data.type === 'clue' && !isMobile) {
      chain = await fetchClueFieldkeys()
      commit('setIsClue', true)
    } else {
      chain = await getConfig()
    }
    chain
      .onSuccess(async payload => {
        await commit('SET_ADD_CONFIG', payload)
        commit('SET_LOADING', false)
      })
      .onNetSuccess((raw = {}) => {
        let { data = {} } = raw
        commit('setBaseInfo', data.baseinfo)
      })
    return chain
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
